<template>
  <div id="main" class="wh1200">
    <div class="crumbs">
      <div class="name">您现在所在位置：</div>
      <div class="crumbs_box">
        <a href="/">首页</a>
        <a href="javascript:history.go(-1)">专题内容列表</a>
      </div>
    </div>
    <div class="zhuanti_img"><img :src="cont.face" alt=""></div>
    <div class="zhuanti_top">
      <div class="zhuanti_title">{{cont.title}}</div>
      <div class="zhuanti_text">
        {{cont.content}}
      </div>
    </div>
	<div class="clear"></div>
    <div class="jiaodian_box">
      <div class="home_title"><span class="left">焦点关注</span></div>
      <ul class="jiaodian_list">
        <li v-for="item in list" :key="item">
          <a href="javascript:;" @click="pages(item.special_item_id)">
            <div class="left_box_img"
              :style="{'background': 'url(' + item.face + ')', 'background-repeat':'no-repeat','background-position':'center'}">
            </div>
            <div class="right_box_text">
              <div class="right_box_con">
                <div class="name">{{item.title}}</div>
                <div class="wenzi" v-html="item.content"></div>
                <div class="time"><img src="../../static/time_icon.png" alt="">{{item.time}}</div>
              </div>
            </div>
            <div class="clear"></div>
          </a>
        </li>
      </ul>
      <pages @changPage="changPage" :count="count" v-if='list.length>0'></pages>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import pages from '@/components/pages'
  import news from '@/api/modules/news'
  export default {
    data() {
      return {
        count: 1,
        sendFrom: {
          'pageSize': 10,
          'page': 1,
          'types': this.$route.query.id
        },
        from: {
          'special_id': this.$route.query.id
        },
        list: [],
        cont: [],
      }
    },
    components: {
      pages
    },
    created() {
      this.init()
      this.content()
    },
    methods: {
      changPage(index) {
        this.sendFrom.page = index
        this.init()
      },

      pages(id) {
        this.$router.push({
          path: '/oneitem',
          query: {
            'id': id
          }
        })
      },

      init() {
        axios({
          method: 'post',
          url: news.topicont,
          data: this.sendFrom
        }).then(res => {
          this.count = Number.parseInt(Math.ceil(res.data.count / 10))
          this.list = res.data.list;
          console.log(res.data.count / 10);
        })
      },
      content() {
        axios({
          method: 'post',
          url: news.content,
          data: this.from
        }).then(res => {
          this.cont = res.data
        })
      }
    }
  }

</script>
<style scoped>
  @import '../../style/public';
  @import '../../style/comm';
  .clear{
	clear:both;
  }
  .zhuanti_top{
	border-left:7px solid #cc0001;
  }
  .zhuanti_top:after{
	background:none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/topicont.vue